

































export default {
  props: {
    buttonText: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    isRounded: {
      type: Boolean,
      required: false,
      default: true,
    },
    isOutlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    isText: {
      type: Boolean,
      required: false,
      default: false,
    },
    isNuxtLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAnchor: {
      type: Boolean,
      required: false,
      default: false,
    },
    link: {
      type: String,
      required: false,
    },
    isSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonClassName: {
      type: String,
      required: false,
      default: 'dark--text',
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
    anchorClassName: {
      type: String,
      required: false,
    },
    nuxtLinkClassName: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    eventName: {
      type: String,
      required: false,
    },
    payload: {
      type: Object,
      required: false,
    },
    iconName: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    linkFormatted: {
      type: String,
      required: false,
    },
  },
}
